import "../App.css";

const WaitingForPromptsRender = () => {
  return (
    <div className="loading-container">
      <div className="rect rect1" />
      <div className="rect rect2" />
      <div className="rect rect3" />
      <div className="rect rect4" />
    </div>
  );
};

export default WaitingForPromptsRender;
